export const SectionLabel = ({ children, center = false, light = false }) => (
  <div className={`flex items-center gap-4 mb-6 ${center ? "justify-center" : ""}`}>
    <span className={`h-px w-10 ${light ? "bg-wine/50" : "bg-gold/50"}`} />
    <span
      data-testid={`section-label-${String(children).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`font-mono text-[11px] uppercase tracking-[0.35em] ${light ? "text-wine" : "text-gold/80"}`}
    >
      {children}
    </span>
    {center && <span className={`h-px w-10 ${light ? "bg-wine/50" : "bg-gold/50"}`} />}
  </div>
);
